import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { updateChoice } from "areas/product/store/actions"
import { Typography } from "components/common/index"
import { to_currency } from "helpers/number"
import { filterProductOptions } from "helpers/product/product-filtering"
import { useNavigation } from "helpers/use-navigation"

import {
  ChoiceOption,
  OptionTitle,
  OptionPrice,
  OptionsSlider,
  GradientContainer,
} from "./components"

const FaceOptionTitle = styled.h3`
  color: #313131;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.5px;
  margin: 0 0 3px;
`

const FaceOptionAttribute = styled.p`
  color: #a0a0a0;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.5px;
  margin: 0;
`

const FaceDescriptionWrapper = styled(Typography).attrs({
  as: "div",
})`
  min-height: 77px;
  margin-bottom: 10px;
  padding-left: 0;
  padding-bottom: 10px;
  border-bottom: dotted thin #cccccc;
  &.hide_attributes {
    min-height: 50px;
  }
`

const ContentWrapper = styled(GradientContainer)`
  padding-left: 10px;
  padding-right: 10px;
  @media (min-width: 768px) {
    padding-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
`
const ChoiceOptions = ({
  faceFiltered,
  setFace,
  selectedValue,
  setChoice,
  data,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label={`Side ${data.heading.title} Options`}
      data-slider="true"
      role="radiogroup"
    >
      {faceFiltered.map((fv) => {
        const selected = selectedValue.value == fv.value
        return (
          <ChoiceOption
            aria-selected={selected}
            data-description={fv.description}
            data-description2={fv.description2}
            data-is-option="true"
            data-is-selected={selectedValue == fv.value}
            data-pref={fv.pref}
            data-price={fv.price}
            data-sia={fv.sia}
            data-specs={fv.specs}
            data-summary-field={fv.summary}
            data-title={fv.title}
            data-value={fv.value}
            key={`li-sliderFaceOption-${fv.value}`}
            onClick={(e) => setChoice(data.pref, fv, e)}
            onMouseOut={() => {
              setFace(selectedValue)
            }}
            onMouseOver={() => {
              setFace(fv)
            }}
            role="radio"
            selected={selected}
            style={{ flexBasis: "110px" }}
            tabIndex={selected ? 0 : -1}
            {...keyboardProps}
          >
            <img
              alt={fv.title}
              height="50"
              src={fv.image}
              title={fv.title}
              width="50"
            />

            <OptionTitle>{fv.title}</OptionTitle>

            <OptionPrice>
              {fv.price > 0 ? to_currency(fv.price) : ""}
            </OptionPrice>
          </ChoiceOption>
        )
      })}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  faceFiltered: PropTypes.array,
  selectedValue: PropTypes.object,
  setChoice: PropTypes.func,
  setFace: PropTypes.func,
}
const InternalFaceOptions = ({ data, selectedValue, filter, setChoice }) => {
  if (!data) {
    return null
  }

  const [face, setFace] = useState(selectedValue)
  const faceFiltered = filterProductOptions(data.options, filter, true)

  return (
    <div>
      <ContentWrapper>
        <FaceDescriptionWrapper display={{ _: "none", tablet: "block" }}>
          <FaceOptionTitle>
            {face.title} - {to_currency(face.price)}
          </FaceOptionTitle>

          <FaceOptionAttribute>{face.description}</FaceOptionAttribute>
        </FaceDescriptionWrapper>
        <FocusScope restoreFocus>
          <ChoiceOptions
            data={data}
            faceFiltered={faceFiltered}
            selectedValue={selectedValue}
            setChoice={setChoice}
            setFace={setFace}
          />
        </FocusScope>
      </ContentWrapper>
    </div>
  )
}

InternalFaceOptions.propTypes = {
  data: PropTypes.object,
  filter: PropTypes.object,
  selectedValue: PropTypes.object,
  setChoice: PropTypes.func,
}

const getProductFilter = ({ choices }) => {
  const pref = "sku"
  let value = ""
  if (choices && choices.sku && choices.sku.title) {
    value = choices.sku.value
  }
  return { pref, value }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.wizard.data[ownProps.pref],
    filter: getProductFilter(state),
    selectedValue: state.choices[ownProps.pref] || {},
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
    },
  }
}

const FaceOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalFaceOptions)

export default FaceOptions
